import {get} from '../utils/http';
import Route from '../models/Route';

/**
 * 获取多个poi点组成的路线
 *
 * @export
 * @param {string} poi_uids 用`,`分隔的n个`poi_uid`
 * @returns
 */
export function getRouteByPoiUids(poi_uids, trip_id) {
  let url = '/m/v2/?m=api/route/get_by_poi_uid';

  return get(url, {
    data: {poi_uids, trip_id}
  })
    .then(function (data) {
      let result = {};

      for (let key in data.routes) {
        result[key] = Route.parseInput(data.routes[key]);
      }

      return result;
    });
}



// WEBPACK FOOTER //
// ./src/services/route.js